import { call, put, takeLatest } from 'typed-redux-saga/macro';
import { actions } from '../ducks/programs';
import { getPrograms } from '../../services/programs.service';

function* getProgramDataRequestSaga({ payload }: any) {
  try {
    const response = yield* call(getPrograms, payload.providerId, payload.userId);
    yield* put(actions.getProgramDataSuccess(response.data.data));
  } catch (error) {
    yield* put(actions.getProgramDataError('get_program_data_error'));
  }
}

function* EVisitsSaga() {
  yield takeLatest(actions.getProgramDataRequest, getProgramDataRequestSaga);
}

export default EVisitsSaga;
